import React, { createContext, useContext } from 'react';

const ColorContext = createContext();

export const ColorProvider = ({ children }) => {
  const colors = {
    sidebarBg: "#2C7A7B",
    navbarBg: "#2C7A7B",
    hoverBg: "blue.700",
    selectedMenuColor: "orange",
    textColor: "white",
    userTextColor: 'teal',
    buttonColor: "red",
    btncolor:"#ff8f00"

  };

  return (
    <ColorContext.Provider value={colors}>
      {children}
    </ColorContext.Provider>
  );
};

export const useColors = () => {
  return useContext(ColorContext);
};
